export const QUESTION_TITLE_THUMB_WIDTH = 27
export const QUESTION_TITLE_THUMB_HEIGHT = 27
export const QUESTION_TITLE_IMAGE_WIDTH = 320
export const QUESTION_TITLE_IMAGE_HEIGHT = 6000
export const QUESTION_TITLE_IMAGE_MIN_WIDTH = 70
export const QUESTION_TITLE_IMAGE_MAX_WIDTH = 265
export const QUESTION_TITLE_IMAGE_MIN_HEIGHT = 70
export const QUESTION_TITLE_IMAGE_MAX_HEIGHT = 265

export const TYPE_VARIANT_MAP = {
  dlv: 'vq',
  dlc: 'cq',
  dlx: 'xq',
  dld: 'cl',
  dlt: 'tl',
  sn: 'sn'
}

export const TYPE_DND_MAP = {
  dlv: 'question-custom',
  dlc: 'question-custom-cf',
  dlx: 'question-custom-xpert',
  dld: 'question-custom-concept',
  dlt: 'question-custom-tracker',
  sn: 'question-custom-sn'
}

export const TYPE_FEATURE_MAP = {
  dlv: 'data_lab_vq',
  dlc: 'data_lab_cf',
  dlx: 'data_lab_xpert',
  dld: 'data_lab_concept',
  dlt: 'data_lab_tracker',
  sn: 'data_lab_storytelling'
}

export const TYPE_CLASS_MAP = {
  dlv: 'virtual-question',
  dlc: 'correlation-finder',
  dlx: 'xpert-question',
  dld: 'concept-question',
  dlt: 'tracker-question'
}

export const QUESTION_ANNOTATION_LIMIT = 9999
